import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegalPageLayout = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-[#2A0505] text-amber-50/90 font-tamil-body selection:bg-amber-500/30">
      {/* Background Decor */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-amber-500/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-violet-500/5 blur-[120px] rounded-full translate-y-1/2 -translate-x-1/2" />
      </div>

      {/* Navigation Header */}
      <nav className="sticky top-0 z-50 bg-[#2A0505]/80 backdrop-blur-md border-b border-amber-500/10">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link 
            to="/melmalaiyanoor-Angalamman" 
            className="flex items-center gap-2 text-amber-400 hover:text-amber-300 transition-colors group"
          >
            <ChevronLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            <span className="font-semibold">Back to Home</span>
          </Link>
          <div className="text-xl">🔱</div>
        </div>
      </nav>

      {/* Content */}
      <main className="relative z-10 max-w-4xl mx-auto px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-tamil-heading text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-amber-200 to-amber-500 mb-12 text-center">
            {title}
          </h1>
          
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-3xl shadow-2xl">
            <div className="prose prose-invert prose-amber max-w-none">
              {children}
            </div>
          </div>
        </motion.div>
      </main>

      {/* Simplified Footer */}
      <footer className="relative z-10 py-12 text-center border-t border-white/5">
        <div className="max-w-4xl mx-auto px-6">
          <p className="text-amber-200/30 text-sm">
            © 2026 Arulvaaku Nilayam. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LegalPageLayout;
